var _circle, _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUserOrangeCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    fill: "#E57200"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4728 19.1579V17.7895C18.4728 17.0636 18.1844 16.3675 17.6712 15.8542C17.1579 15.341 16.4618 15.0526 15.7359 15.0526H10.2622C9.53638 15.0526 8.84025 15.341 8.32699 15.8542C7.81374 16.3675 7.52539 17.0636 7.52539 17.7895V19.1579",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0005 12.3157C14.512 12.3157 15.7374 11.0904 15.7374 9.57888C15.7374 8.06737 14.512 6.84204 13.0005 6.84204C11.489 6.84204 10.2637 8.06737 10.2637 9.57888C10.2637 11.0904 11.489 12.3157 13.0005 12.3157Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserOrangeCircle);
export default __webpack_public_path__ + "static/media/user-orange-circle.6f59d5741bdb91b9105abd18606c963a.svg";
export { ForwardRef as ReactComponent };